import { YUP_VALIDATIONS } from '@plug/helpers/yup-helpers';
import * as Yup from 'yup';

export const OrganizationRegisterOrganizationDataSchema = Yup.object().shape({
  organization_name: YUP_VALIDATIONS.organization_name,
  contact_email: YUP_VALIDATIONS.email,
  cnpj: YUP_VALIDATIONS.cnpj,
  organization_phone: YUP_VALIDATIONS.organization_phone,
  organization_type: YUP_VALIDATIONS.organization_type,
});
